module.exports = __webpack_public_path__ + "img/img-voice02.75992447.png";